<template>
  <div class="d-flex justify-content-center ">
  <div class="spinner-border my-2" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
</template>